<template>
  <div>
    <el-upload
      v-if="!disabled"
      :action="uploadAction"
      drag
      :multiple="false"
      :show-file-list="false"
      auto-upload
      :headers="headers"
      name="image"
      :on-error="handleError"
      :on-success="onSuccess"
      :on-change="handleChange"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text" v-html="$t('fileUpload.dragAndDropHtml')"></div>
      <div slot="tip" class="el-upload__tip">{{ $t('fileUpload.uploadTip') }}</div>
    </el-upload>
    <app-file
      v-if="showFileList && currentValue"
      :disabled="disabled"
      :file="currentValue"
      :download-action="downloadAction"
      :delete-action="deleteAction"
      @remove="handleRemove"
    />
  </div>
</template>

<script>
import AppFile from './AppFile';
import { getToken } from '@/utils/auth';
import { baseURL } from '@/utils/request';

export default {
  components: {
    AppFile
  },
  props: {
    value: String,
    appendEntityId: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    uploadRoute: {
      type: String
    },
    downloadAction: {
      type: String
    },
    deleteAction: {
      type: String
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    onSuccess: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      headers: { Authorization: 'Bearer ' + getToken() },
      currentValue: null
    };
  },
  computed: {
    entityID() {
      return this.$route.params && this.$route.params.id;
    },
    uploadAction() {
      let action = `${baseURL}/${this.uploadRoute}`;
      if (this.appendEntityId) {
        action = `${action}/${this.entityID}`;
      }
      return action;
    }
  },
  watch: {
    value(fileName) {
      if (fileName) {
        this.currentValue = {
          name: fileName,
          percentage: 100,
          status: 'success'
        };
      }
    }
  },
  methods: {
    handleChange(file, fileList) {
      if (file && file.status === 'success') {
        this.currentValue = file;
      }
    },
    handleError(error) {
      this.$store.dispatch('notify/error', error);
    },
    handleRemove(file) {
      this.currentValue = null;
    }
  }
};
</script>
